<div id="aerovalePrint" *ngIf="aerovaleDetalle" class="card">
  <div #aerovalePrintRef class="card-body">
    <div class="d-flex justify-content-between">
      <div class="p-2">
        <img id="logo-ypf" src="../../../assets/images/logoypf.png" /> <!--assets/images/logoypf.png-->
      </div>
      <div class="p-2 text-center">
        <h3>Aerovale</h3>
        <h6>{{ aerovaleDetalle.tipoAerovale !== TipoAerovale.IATANivelDosTres ? getTipoAerovale() : "IATA Nivel 2/3" }}</h6>
      </div>
      <div class="p-2 text-end">
          N°:
          <b> 
            @if (aerovaleDetalle.numeroAerovale) {
              {{ aerovaleDetalle.prefijo | aerovalePrefijo }}{{ aerovaleDetalle.numeroAerovale | aerovaleNumero }}
            } @else {
              0
            }
          </b>
          <br> Fecha:
          <b>{{ aerovaleDetalle.fechaHoraFinDespacho | date: "d'/'MM'/'y' " }} </b>
      </div>
    </div>
    <div *ngIf="aerovaleDetalle.origen" class="d-flex flex-column">
      <div class="p-2">Aeroplanta: <b> {{ aerovaleDetalle.origen.nombre }} </b> </div>
    </div>
    <div class="d-flex flex-column">
      <div class="p-2">Cliente: <b>{{ aerovaleDetalle.cliente.razonSocial }} </b> </div>
    </div>
    <div class="d-flex flex-column">
      <div class="p-2">Nro. cuenta: <b>{{ aerovaleDetalle.cliente.numeroCuenta }} </b> </div>
    </div>
    <div class="d-flex">
      <div>
        <div class="d-flex ">

          <div *ngIf="aerovaleDetalle.vehiculo" class="p-2">Matrícula: <b>{{ aerovaleDetalle.vehiculo.matricula }} </b>

          </div>
          <div *ngIf="aerovaleDetalle.vuelo" class="p-2">Vuelo:
            <b>{{ aerovaleDetalle.vuelo ? aerovaleDetalle.vuelo : '----' }}
            </b>
          </div>

        </div>
        <div class="d-flex">
          <div *ngIf="aerovaleDetalle.detalleAerocombustible && !esAlije()" class="p-2">Destino:
            <b>{{this.getTipoVuelo(this.aerovaleDetalle.detalleAerocombustible.tipoVuelo).toUpperCase()}}</b>

            <b *ngIf="aerovaleDetalle.detalleAerocombustible.destino"> -
              [{{ aerovaleDetalle.detalleAerocombustible.codigoAeropuerto }}]
              {{aerovaleDetalle.detalleAerocombustible.destino }}
            </b>
          </div>
        </div>
        <div class="d-flex">
          <div class="p-2">Condición de Venta: <b>{{ this.getTipoPago(aerovaleDetalle.tipoPago) }}
            </b> </div>
        </div>
        <div class="d-flex">
          <div *ngIf="aerovaleDetalle.detalleAerocombustible && !esAlije()" class="p-2">Rancho N°:
            <b>{{ aerovaleDetalle.detalleAerocombustible.rancho? aerovaleDetalle.detalleAerocombustible.rancho : '----'
              }}
            </b>
          </div>
        </div>
      </div>
      <div *ngIf="aerovaleDetalle.estado === 'Anulado' || mostrarImagenAnulado" class="me-auto">
        <img id="logo-ypf" src="assets/images/Anulado.png" />
      </div>
    </div>
    <hr>
    <div class="d-flex">
      <div *ngIf="aerovaleDetalle.operadorDTO" class="me-auto p-2">Operador:
        <b>{{ aerovaleDetalle.operadorDTO.nombreCompleto }} </b>
      </div>
      <div *ngIf="aerovaleDetalle.operadorDTO" class="p-2">Documento Nº:
        <b>{{ aerovaleDetalle.operadorDTO.dni ? aerovaleDetalle.operadorDTO.dni : '----' }} </b>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div *ngIf="aerovaleDetalle.abastecedora" class="p-2">Abastecedora interna Nº:
        <b>{{ aerovaleDetalle.abastecedora.nombre }}
        </b>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="p-2">Observaciones:
        <b *ngIf="ObserNormal.length == 0">----</b>
        <b *ngFor="let observacion of ObserNormal">{{ observacion.nombre }} </b>
      </div>
    </div>
    <div class="d-flex flex-column" *ngIf="aerovaleDetalle.estado === 'Anulado'">
      <div class="p-2 text-danger">Observaciones de anulación:
        <b *ngFor="let observacionA of ObserAnulado" class="text-danger">{{ observacionA.nombre }}</b>
      </div>
    </div>
    <hr>
    <div class="d-flex flex-column"
      *ngIf="aerovaleDetalle.tipoAerovale == TipoAerovale.Aerocombustible || aerovaleDetalle.tipoAerovale == TipoAerovale.Devolucion || aerovaleDetalle.tipoAerovale == TipoAerovale.Alije">
      <div class="p-2">Hora de llegada: <b>{{ aerovaleDetalle.fechaHoraLlegada | date: "hh:mm a" }} </b> </div>
    </div>
    <div class="d-flex flex-column">
      <div class="p-2">Hora de inicio: <b>{{ aerovaleDetalle.fechaHoraInicioDespacho | date: "hh:mm a"}} </b> </div>
    </div>
    <div class="d-flex flex-column">
      <div class="p-2">Hora de finalizacion: <b>{{ aerovaleDetalle.fechaHoraFinDespacho | date: "hh:mm a" }} </b>
      </div>
    </div>
    <div *ngIf="aerovaleDetalle.detalleAerocombustible" class="d-flex justify-content-between">
      <div class="p-2">Prueba de Agua: <b>{{ aerovaleDetalle.detalleAerocombustible.pruebaAgua? 'NEG' : 'POS' }}</b>.
      </div>
      <div class="p-2">Temperatura: <b>{{ aerovaleDetalle.detalleAerocombustible.temperatura | number : '0.1-1' }} °C
        </b></div>
      <div class="p-2">Densidad: <b>{{ aerovaleDetalle.detalleAerocombustible.densidad.toFixed(3) }} g/cm3 </b> </div>
    </div>
    <div *ngIf="aerovaleDetalle.detalleAerocombustible" class="d-flex justify-content-between">
      <div class="p-2">Volumen 15º: <b>{{ aerovaleDetalle.detalleAerocombustible.volumen15grados | number : '0.0-0' }} LTS </b></div>
    </div>


    <div *ngIf="aerovaleDetalle.detalleCombustible" class="d-flex justify-content-between">
      <div class="p-2">Volumen 15º: <b> {{aerovaleDetalle.detalleCombustible.volumen15grados}} LTS </b>.
      </div>
      <div class="p-2">Temperatura: <b>{{ aerovaleDetalle.detalleCombustible.temperatura}}°C
        </b></div>
      <div class="p-2">Densidad: <b> {{ aerovaleDetalle.detalleCombustible.densidad.toFixed(3)}} g/cm3 </b> </div>
    </div>

    <hr>
    <div *ngIf="esAlije()">
      <div class="me-auto p-2">LABORATORIO: <b>{{this.getLaboratorio(aerovaleDetalle.detalleAerocombustible.aerovaleDetalleAlije.codigoLaboratorio)}}</b></div>
      <div class="d-flex justify-content-between">
        <div class="p-2">Fecha:
          <b>{{aerovaleDetalle.detalleAerocombustible.aerovaleDetalleAlije.fechaPruebaLaboratorio | date: "dd/MM/y"
            }}</b>
        </div>
        <div class="p-2">Código de prueba:
          <b>{{aerovaleDetalle.detalleAerocombustible.aerovaleDetalleAlije.codigoPruebaLaboratorio}}</b>
        </div>
        <div class="p-2">
          <b>{{
            getEstadoPruebaLaboratorio(aerovaleDetalle.detalleAerocombustible.aerovaleDetalleAlije.estadoPruebaLaboratorio)
            }}</b>
        </div>
      </div>
      <hr>
    </div>
    <div *ngIf="aerovaleDetalle.tipoAerovale==TipoAerovale.Aerocombustible || aerovaleDetalle.tipoAerovale==TipoAerovale.Combustible || 
        aerovaleDetalle.tipoAerovale==TipoAerovale.Alije || aerovaleDetalle.tipoAerovale==TipoAerovale.Devolucion">
      <div class="d-flex">
        <div class="me-auto p-2">TOTALIZADOR INICIO: </div>
        <div class="p-2">{{ obtenerAforadorInicioDeAerovale() | number : '0.0-0' }}</div>
      </div>
      <div class="d-flex">
        <div class="me-auto p-2">TOTALIZADOR FINAL: </div>
        <div class="p-2">{{ obtenerAforadorFinDeAerovale() | number : '0.0-0' }}</div>
      </div>
      <div class="d-flex">
        <div class="me-auto p-2">VOLUMEN BRUTO FINAL LTS: </div>
        <div class="p-2">{{ aerovaleDetalle.volumen | number : '0.0-0' }}</div>
      </div>
      <div *ngIf="aerovaleDetalle.tipoAerovale==TipoAerovale.Alije">
        <div class="d-flex">
          <div class="me-auto p-2">Aforador Inicial: </div>
          <div class="p-2">
            {{ aerovaleDetalle.detalleAerocombustible.aforadorInicio | number : '0.0-0' }}</div>
        </div>
        <div class="d-flex">
          <div class="me-auto p-2">Aforador Final: </div>
          <div class="p-2">
            {{ aerovaleDetalle.detalleAerocombustible.aforadorFinal | number : '0.0-0' }}</div>
        </div>
      </div>
    </div>
    <hr *ngIf="aerovaleDetalle.detalleAerocombustible">
    <div *ngIf="aerovaleDetalle.producto" class="d-flex bg-dark text-white">
      <div class="p-2 col col-md-6">
        <b>Producto</b>
      </div>
      <div class="p-2 col col-md-3 text-end">
        <b>Código</b>
      </div>
      <div class="p-2 col col-md-3 text-end">
        <b
          *ngIf="aerovaleDetalle.detalleAerocombustible && aerovaleDetalle.detalleAerocombustible.aerovaleDetalleAlije; else abastecida">
          Cant. de alije</b>
        <ng-template #abastecida>
          <b>Cant. abastecida</b>
        </ng-template>
      </div>
    </div>
    <div *ngIf="aerovaleDetalle.producto" class="d-flex">
      <div class="p-2 col col-md-6">
        {{ aerovaleDetalle.producto.nombreProducto }}
      </div>
      <div class="p-2 col col-md-3 text-end">
        {{ aerovaleDetalle.producto.codigoProducto }}
      </div>
      <div class="p-2 col col-md-3 text-end">
        {{ aerovaleDetalle.volumen | number : '0.0-0'}} LTS
      </div>
    </div>
    <div *ngIf="aerovaleDetalle.aeroespecialidades && aerovaleDetalle.aeroespecialidades.length > 0"
      class="d-flex bg-dark text-white">
      <div class="p-2">
        <b>Aeroespecialidades</b>
      </div>
    </div>
    <div *ngFor="let aesp of aerovaleDetalle.aeroespecialidades" class="d-flex">
      <div class="me-auto p-2"> {{ aesp.nombreProducto }}: </div>
      <div class="p-2">{{ aesp.cantidad }} unidad/es</div>
    </div>
    <hr>

    <div *ngIf="aerovaleDetalle.servicios && aerovaleDetalle.servicios.length > 0"
      class="d-flex bg-dark text-white">
      <div class="p-2">
        <b>Servicios</b>
      </div>
    </div>
    <div *ngFor="let s of aerovaleDetalle.servicios" class="d-flex">
      <div class="me-auto p-2"> {{ s.nombreProducto }}: </div>
      <div class="p-2">{{ s.cantidad }} unidad/es</div>
    </div>
    <hr>
    
    <div *ngIf="aerovaleDetalle.comentarios">
      <div class="form-check no-print">
        <input type="checkbox" [(ngModel)]="mostrarComentario" class="custom-control-input" id="defaultChecked2"
          checked>
        <label class="custom-control-label" for="defaultChecked2"><b>&nbsp; Imprimir comentario</b></label>
      </div>
      <div *ngIf="mostrarComentario" class="d-flex flex-column">
        <div class="p-2">Comentarios:
        </div>
        <div class="p-2 me-2">
          <b>{{ aerovaleDetalle.comentarios }}</b>
        </div>
      </div>
    </div>
    <hr *ngIf="aerovaleDetalle.comentarios && mostrarComentario">

    <div *ngIf="aerovaleDetalle.detalleAerocombustible && aerovaleDetalle.detalleAerocombustible.esGranel">
      <div class="form-check no-print">
        <input type="checkbox" [(ngModel)]="mostrarDDJJGranel" class="custom-control-input" id="checkMostrarDDJJ"
          checked>
        <label class="custom-control-label" for="checkMostrarDDJJ"><b>Mostrar DDJJ Granel</b></label>
      </div>
      <div *ngIf="mostrarDDJJGranel" class="d-flex flex-column" style="margin-top: 1em;">
        <div style="font-weight: bold;">VENTA A GRANEL</div>
        <br/>
        <div>Por la presente, se certifica con carácter de declaración jurada, que el codigoProducto arriba detallado, entregado en el día de la fecha  será destinado al consumo de aeronaves exclusivamente. </div>
        <br/>
        <div>Se declara asimismo conocer y respetar las reglamentaciones vigente y aplicables en materia de transporte, almacenaje y carga de aerocombustibles. </div>
        <br/>
        <div>Se deslinda de toda responsabilidad a YPF S.A. Por cualquier alteración de la propiedad, contaminación, y/o modificación de la aptitud para el uso aeronáutico del producto entregado que pudiera ocurrir con posterioridad a la carga vía punta de manguera efectuada y respaldada con la presente documentación. </div>
        <br/>
        <div>Para lo cual se declara disponer de instalaciones aptas para el almacenaje y posterior carga del producto en aeronaves, en un todo de acuerdo a lo especificado por las normas técnicas aplicables y las disposiciones nacionales, provinciales y municipales, en materia de salud, seguridad y protección al medio ambiente. </div>
        <br/>
        <div>Se deja constancia, que todo manejo del producto, con posterioridad a la entrega (por eje.: almacenaje para cargas futuras, despachos a través de surtidores, etc.) se realizara con elemento sin identificación empresarial alguna. Sin existir responsabilidad por parte de YPF S.A luego de efectuada la descarga del producto.</div>
      </div>
    </div>

    <ng-container *ngIf="!this.esAevReemplazo()">
      <div class="d-flex justify-content-between" *ngIf="this.esContingencia===false && mostrarFirma()===true">        
          <img *ngIf="ImagenFirmaOperador()!=''" class="flex-fill w-50 img-fluid print-resize" [src]="this.ImagenFirmaOperador()" />
          <img *ngIf="ImagenFirmaCliente()!=''" class="flex-fill w-50 img-fluid print-resize" [src]="this.ImagenFirmaCliente()" />
      </div>
      <div class="d-flex justify-content-between" *ngIf="this.esContingencia===true && mostrarFirma()===true">
        <img *ngIf="ImagenFirmaOperador()!=''" class="flex-fill w-50 img-fluid print-resize" [src]="this.ImagenFirmaOperador()" />
      </div>
      <div class="d-flex justify-content-between" *ngIf="this.esContingencia===false && mostrarFirma()===true">
        <div *ngIf="ImagenFirmaOperador()!=''" class="flex-fill w-50  text-center">Firma del operador</div>
        <div *ngIf="ImagenFirmaCliente()!=''" class="flex-fill w-50  text-center">Firma del cliente</div>
      </div>

      <div class="d-flex justify-content-between" *ngIf="this.esContingencia===true && mostrarFirma()===true">

        <div *ngIf="ImagenFirmaOperador()!=''" class="flex-fill w-50  text-center">Aerovale Físico</div>

      </div>

      <br>
      <div class="text-center"><small><b>Aerovale original generado por Sistema Electronico</b></small></div>
    </ng-container>    
  </div>
</div>

<!-- se quita del #id="aerovalePrint" para que no capture el reemplazo de reemplazos el archivo físico-->
<ng-container *ngIf="this.esAevReemplazo()">

  <div class="d-flex justify-content-between" *ngIf="mostrarFirma()===true">
    <img
      *ngIf="this.aerovaleDetalle.firmaOperador!=null || this.aerovaleDetalle.firmaOperador!='' || this.aerovaleDetalle.pathFirmaOperador!=null || this.aerovaleDetalle.pathFirmaOperador!=''"
      class="flex-fill w-50 img-fluid print-resize" [src]="this.ImagenFirmaOperador()" />
  </div>

  <div class="d-flex justify-content-between" *ngIf="mostrarFirma()===true">

    <div *ngIf="ImagenFirmaOperador()!=''" class="flex-fill w-50  text-center">Aerovale Físico</div>

  </div>

  <br>
  <div class="text-center"><small><b>Aerovale original generado por Sistema Electronico</b></small></div>

</ng-container>
